import { Component } from '@angular/core';

@Component({
    templateUrl: './catalog-help.component.html',
    standalone: false
})
export class CatalogHelpComponent { }
